/**
 * The upgrade offer for a Pro feature, mounted once for the whole app
 * (App.tsx): opened by utils/proWall.js's event, from a button that knew the
 * account is on the free plan or from an API refusal.
 */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useLocale } from '../../i18n/LocaleContext';
import { useUsageStore } from '../../stores/usageStore';
import { track } from '../../analytics/track';
import { PRO_WALL_EVENT } from '../../utils/proWall';
import UpgradeOffer from './UpgradeOffer';

export default function ProWall() {
  const { t } = useLocale();
  const navigate = useNavigate();
  const [wall, setWall] = useState(null);
  // Nothing made yet this period: the free way forward is the main button (ux-guy, 2026-10-04)
  const madeNothing = useUsageStore((state) => state.metrics?.ai_agent_projects?.used === 0);
  useEffect(() => {
    const open = (event) => {
      const { reason, from } = event.detail || {};
      if (!reason) return;
      track(`${reason}_pro_wall`, { from });
      setWall({ reason, from });
    };
    window.addEventListener(PRO_WALL_EVENT, open);
    return () => window.removeEventListener(PRO_WALL_EVENT, open);
  }, []);
  if (!wall) return null;
  // A character is an extra: the video can be made without one, which the wall says
  const alternative = wall.reason === 'characters'
    ? {
      label: t('upgrade.withoutCharacters'),
      icon: Sparkles,
      primary: madeNothing,
      // From the picker the video is right there; from the Characters page closing the wall
      // left them on it, and the next press opened the wall again (ux-guy, 2026-10-05: one
      // person 3 times in 28 s). video=1: the create page makes the narrated video at once
      onClick: () => { if (wall.from === 'characters_page') navigate('/ai-agent?video=1'); },
    }
    : null;
  return <UpgradeOffer open onClose={() => setWall(null)} reason={wall.reason} tool="ai-agent" source={`${wall.reason}_${wall.from || 'wall'}`} alternative={alternative} />;
}
